import { render, staticRenderFns } from "./flowEditor.vue?vue&type=template&id=52d34dab&scoped=true&lang=pug"
import script from "./flowEditor.vue?vue&type=script&lang=js"
export * from "./flowEditor.vue?vue&type=script&lang=js"
import style0 from "./flowEditor.vue?vue&type=style&index=0&id=52d34dab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d34dab",
  null
  
)

export default component.exports